module.exports = __webpack_public_path__ + "static/media/galleryImg16.244e2a9d.jpg";